const models = [
  {
    image: require("assets/images/chery/TIGGO_9.png"), title: "TIGGO 9", link: "TIGGO_9",
  },
  {
    image: require("assets/images/chery/TIGGO_8_PRO_MAX.png"), title: "TIGGO 8 PRO MAX", link: "TIGGO_8_PRO_MAX",
  },
  {
    image: require("assets/images/chery/TIGGO_8_PRO_Plug-In_Hybrid.png"), title: "TIGGO 8 PRO Plug-In Hybrid", link: "TIGGO_8_PRO_Plug-In_Hybrid",
  },
  {
    image: require("assets/images/chery/TIGGO_7_PRO_MAX.png"), title: "TIGGO 7 PRO MAX", link: "TIGGO_7_PRO_MAX",
  },
  {
    image: require("assets/images/chery/TIGGO_7_PRO_Plug-In_Hybrid.png"), title: "TIGGO 7 PRO Plug-In Hybrid", link: "TIGGO_7_PRO_Plug-In_Hybrid",
  },
  {
    image: require("assets/images/chery/TIGGO_4_PRO.png"), title: "TIGGO 4 PRO", link: "TIGGO_4_PRO",
  },
  {
    image: require("assets/images/chery/TIGGO_2_PRO.png"), title: "TIGGO 2 PRO", link: "TIGGO_2_PRO",
  },
  {
    image: require("assets/images/chery/ARRIZO_8.png"), title: "ARRIZO 8", link: "ARRIZO_8",
  },
  {
    image: require("assets/images/chery/ARRIZO_6.png"), title: "ARRIZO 6", link: "ARRIZO_6",
  },
];

export default models;
